import React, { useState, useEffect } from 'react';
import { getPlatformColors } from '../../utils/platform';
import { getApiUrl } from '../../utils/platform';

const TKT1Landing = () => {
  const colors = getPlatformColors();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCompanies = async () => {
      try {
        const response = await fetch(`${getApiUrl()}/api/company/public/partners`);
        if (response.ok) {
          const data = await response.json();
          if (data.status === 1 && data.data && data.data.result) {
            // Filter out companies without logo
            const companiesWithLogo = data.data.result.filter(company => company.logo && company.logo.trim() !== '');
            setCompanies(companiesWithLogo);
          }
        }
      } catch (error) {
        console.error('Error loading companies:', error);
      } finally {
        setLoading(false);
      }
    };

    loadCompanies();
  }, []);

  return (
    <div style={{ 
      background: colors.gradient,
      minHeight: '100vh',
      fontFamily: 'Inter, sans-serif',
      color: 'white'
    }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      {/* Header */}
      <header style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        padding: '1rem 0',
        position: 'fixed',
        width: '100%',
        top: 0,
        zIndex: 1000,
        boxShadow: '0 2px 20px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <img 
                src="/TKT1_logo3.png" 
                alt="TKT1 Logo" 
                style={{
                  width: '40px',
                  height: '40px',
                  objectFit: 'contain',
                  borderRadius: '8px'
                }}
              />
              <a href="#" style={{ 
                fontSize: '1.8rem', 
                fontWeight: '700', 
                color: colors.primary,
                textDecoration: 'none'
              }}>
                TKT1
              </a>
            </div>
            <ul style={{ display: 'flex', listStyle: 'none', gap: '2rem', margin: 0 }}>
              <li><a href="#features" style={{ textDecoration: 'none', color: '#333', fontWeight: '500' }}>Tính năng</a></li>
              <li><a href="#partners" style={{ textDecoration: 'none', color: '#333', fontWeight: '500' }}>Đối tác</a></li>
              <li><a href="#about" style={{ textDecoration: 'none', color: '#333', fontWeight: '500' }}>Giới thiệu</a></li>
              <li><a href="#contact" style={{ textDecoration: 'none', color: '#333', fontWeight: '500' }}>Liên hệ</a></li>
            </ul>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section style={{ 
        padding: '120px 0 80px', 
        textAlign: 'center',
        maxWidth: '1200px',
        margin: '0 auto',
        paddingLeft: '20px',
        paddingRight: '20px'
      }}>
        <h1 style={{ 
          fontSize: '3.5rem', 
          fontWeight: '700', 
          marginBottom: '1.5rem',
          lineHeight: '1.2'
        }}>
          Nền tảng E-commerce Thông minh
        </h1>
        <p style={{ 
          fontSize: '1.3rem', 
          marginBottom: '2rem',
          opacity: '0.9'
        }}>
          Giải pháp toàn diện cho việc quản lý và phát triển kinh doanh online
        </p>
        <a href="#features" style={{
          display: 'inline-block',
          background: '#fff',
          color: colors.primary,
          padding: '15px 30px',
          borderRadius: '50px',
          textDecoration: 'none',
          fontWeight: '600',
          fontSize: '1.1rem',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease'
        }}>
          Khám phá ngay
        </a>
      </section>

      {/* Features Section */}
      <section style={{ 
        padding: '80px 0',
        background: 'white',
        maxWidth: '1200px',
        margin: '0 auto',
        paddingLeft: '20px',
        paddingRight: '20px'
      }}>
        <h2 style={{ 
          textAlign: 'center',
          fontSize: '2.5rem',
          fontWeight: '700',
          marginBottom: '3rem',
          color: '#333'
        }}>
          Tính năng nổi bật
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem',
          marginTop: '3rem'
        }}>
          {[
            {
              icon: '🏪',
              title: 'Smart Seller',
              description: 'Tự động quét đơn từ các nền tảng Etsy, eBay, website... Quản lý trạng thái đơn hàng, kho hàng, nhập hàng từ các xưởng, quản lý tài chính, công nợ, theo dõi các chỉ số: sale, top sản phẩm...'
            },
            {
              icon: '🚚',
              title: 'Smart Fulfillment',
              description: 'Quản lý kho hàng, đơn hàng từ các seller, fulfill đơn cho các seller, quản lý trạng thái đơn fulfill, quản lý tài chính, công nợ, theo dõi các chỉ số...'
            },
            {
              icon: '📊',
              title: 'Smart Insights',
              description: 'Phân tích dữ liệu chi tiết để đưa ra quyết định kinh doanh chính xác và kịp thời.'
            },
            {
              icon: '🤖',
              title: 'Smart AI Automation',
              description: 'Tự động hóa các tác vụ lặp đi lặp lại, tiết kiệm thời gian và tăng hiệu quả làm việc.'
            },
            {
              icon: '👥',
              title: 'Smart Management',
              description: 'Quản lý team hiệu quả với phân quyền chi tiết, tracking performance và collaboration tools.'
            },
            {
              icon: '🔒',
              title: 'Smart Security',
              description: 'Bảo mật dữ liệu cao cấp với encryption, backup tự động và tuân thủ các tiêu chuẩn quốc tế.'
            }
          ].map((feature, index) => (
            <div key={index} style={{
              background: '#f8f9fa',
              padding: '2rem',
              borderRadius: '15px',
              textAlign: 'center',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-5px)';
              e.target.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
            >
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>
                {feature.icon}
              </div>
              <h3 style={{ 
                fontSize: '1.5rem', 
                fontWeight: '600', 
                marginBottom: '1rem',
                color: '#333'
              }}>
                {feature.title}
              </h3>
              <p style={{ color: '#666', lineHeight: '1.6' }}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Partners Section */}
      <section id="partners" style={{ 
        padding: '80px 0',
        background: '#f8f9fa',
        maxWidth: '1200px',
        margin: '0 auto',
        paddingLeft: '20px',
        paddingRight: '20px'
      }}>
                <h2 style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          fontWeight: '700',
          marginBottom: '3rem',
          color: '#333'
        }}>
          Đối tác / Khách hàng
        </h2>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '2rem',
          flexWrap: 'wrap'
        }}>
          {loading ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '2rem',
              color: '#666'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                border: '4px solid #f3f3f3',
                borderTop: '4px solid #667eea',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 1rem'
              }}></div>
              <p>Đang tải danh sách đối tác...</p>
            </div>
          ) : companies.length > 0 ? (
            companies.map((company, index) => (
              <a 
                key={company.company_id || index}
                href={`https://${company.company_shortcode.toLowerCase()}.TKT1.ai`}
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: '#333',
                  transition: 'transform 0.3s ease',
                  padding: '1.5rem',
                  borderRadius: '15px',
                  background: 'white',
                  boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
                  minWidth: '200px',
                  maxWidth: '250px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-5px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                {company.logo ? (
                  <img 
                    src={company.logo} 
                    alt={company.name} 
                    style={{
                      width: 'auto',
                      height: '80px',
                      marginBottom: '1rem',
                      objectFit: 'contain'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'block';
                    }}
                  />
                ) : null}
                <div style={{ 
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  color: '#333',
                  marginBottom: '0.5rem',
                  textAlign: 'center',
                  display: company.logo ? 'none' : 'block'
                }}>
                  {company.name}
                </div>
                {company.description && (
                  <p style={{
                    fontSize: '0.9rem',
                    color: '#666',
                    textAlign: 'center',
                    margin: '0',
                    lineHeight: '1.4',
                    maxHeight: '60px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical'
                  }}>
                    {company.description}
                  </p>
                )}
                {/* Company Type Badges */}
                <div style={{
                  display: 'flex',
                  gap: '0.5rem',
                  marginTop: '0.5rem',
                  flexWrap: 'wrap',
                  justifyContent: 'center'
                }}>
                  {company.is_seller && (
                    <span style={{
                      fontSize: '0.7rem',
                      padding: '2px 6px',
                      backgroundColor: '#e3f2fd',
                      color: '#1976d2',
                      borderRadius: '10px',
                      fontWeight: '500'
                    }}>
                      Seller
                    </span>
                  )}
                  {company.is_factory && (
                    <span style={{
                      fontSize: '0.7rem',
                      padding: '2px 6px',
                      backgroundColor: '#f3e5f5',
                      color: '#7b1fa2',
                      borderRadius: '10px',
                      fontWeight: '500'
                    }}>
                      Factory
                    </span>
                  )}
                  {company.is_shipping_agency && (
                    <span style={{
                      fontSize: '0.7rem',
                      padding: '2px 6px',
                      backgroundColor: '#e8f5e8',
                      color: '#388e3c',
                      borderRadius: '10px',
                      fontWeight: '500'
                    }}>
                      Shipping
                    </span>
                  )}
                </div>
              </a>
            ))
          ) : (
            <div style={{ 
              textAlign: 'center', 
              padding: '2rem',
              color: '#666'
            }}>
              <p>Chưa có đối tác nào được hiển thị</p>
            </div>
          )}
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ 
        padding: '80px 0',
        background: colors.gradient,
        maxWidth: '1200px',
        margin: '0 auto',
        paddingLeft: '20px',
        paddingRight: '20px'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '2rem',
          textAlign: 'center'
        }}>
          {[
            { number: '1000+', label: 'Khách hàng tin tưởng' },
            { number: '50+', label: 'Tính năng thông minh' },
            { number: '99.9%', label: 'Uptime đảm bảo' },
            { number: '24/7', label: 'Hỗ trợ khách hàng' }
          ].map((stat, index) => (
            <div key={index}>
              <h3 style={{ 
                fontSize: '2.5rem', 
                fontWeight: '700', 
                marginBottom: '0.5rem'
              }}>
                {stat.number}
              </h3>
              <p style={{ fontSize: '1.1rem', opacity: '0.9' }}>
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer style={{ 
        background: '#333',
        color: 'white',
        padding: '40px 0',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <p style={{ opacity: '0.8' }}>
            &copy; 2025 TKT1. Tất cả quyền được bảo lưu.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TKT1Landing; 